import Vue from 'vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter)

import { getRentInfo ,getmenuList} from "@/https/http.js";

// 配置项目路由
const router = new VueRouter({
    routes: [{
            path: '/',
            redirect: '/home' // 重定向
        },
        {
            path: '/home/:rentPath', //首页
            name: 'Home',
            component: () => import('@/views/home/Home'),
            children: [ // 二级路由 不能加'/' 加'/'表示一级路由
                {
                    path: 'searchPopup',
                    component:  () => import('@/views/home/search/searchPopup.vue'),
                    name: 'searchpopup',
                    meta: {
                        isshowtabbar: false
                    },
                    

                }
            ],
            meta: {
                isShowTabbar: true
            }
        },
        {
            path: '/case/:rentPath', //案例
            name: 'Case',
            component: () => import('@/views/website/case/index'),
            meta: {
                isShowTabbar: true
            }
        },
        {
            path: '/caseDetail/:rentPath', //案例详情
            name: 'CaseDetail',
            component: () => import('@/views/website/case/caseDetail'),
            meta: {
                isShowTabbar: true
            }
        },
        {
            path: '/activity/:rentPath', //活动
            name: 'Activity',
            component: () => import('@/views/website/activity/index'),
            meta: {
                isShowTabbar: true
            }
        },
        {
            path: '/activityDetail/:rentPath', //活动详情
            name: 'ActivityDetail',
            component: () => import('@/views/website/activity/activityDetail'),
            meta: {
                isShowTabbar: true
            }
        },

        {
            path: '/designer/:rentPath', //设计师
            name: 'Designer',
            component: () => import('@/views/website/designer/index'),
            meta: {
                isShowTabbar: true
            }
        },
        {
            path: '/designerDetail/:rentPath', //设计师详情
            name: 'DesignerDetail',
            component: () => import('@/views/website/designer/designerDetail'),
            meta: {
                isShowTabbar: true
            }
        },


        {
            path: '/rent/:rentPath', //简介
            name: 'Rent',
            component: () => import('@/views/website/rent/index'),
            meta: {
                isShowTabbar: true
            }
        },

        {
            path: '/404', //404
            name: '404',
            component: () => import('@/views/404')
        },

        {
            path: '/444', //444
            name: '444',
            component: () => import('@/views/444')
        },

        {
            path: '/productDetail', //产品详情
            name: 'ProductDetail',
            component: () => import('@/views/productdetail/ProductDetail')
        },
       
    ]
})

// 路由前置守卫
router.beforeEach((to, from, next) => {
    if(to.path == '/404'||to.path == '/444'){
        next();
        return;
    }
    let rentPath = to.params.rentPath
    if(undefined == rentPath || "" == rentPath){
        next("/404"); 
    }else{
        let cacheRent = localStorage.getItem("rent")

        getRentInfo({"rentPath":rentPath}).then(res=>{
            getmenuList({"rentId":res.data.rentId}).then(res1=>{
                localStorage.setItem("menuList",JSON.stringify(res1.data))

                let rent = JSON.stringify(res.data)
                let rentJson = JSON.parse(rent)
                
                if(rentJson.rentStatus==3){
                    window.location.href="https://www.xiaoyangkongjian.cn/xy/xy/index";
                    return;
                }
                if(new Date().getTime()>rentJson.rentEndTime||rentJson.rentStatus!=1){
                    next("/444"); 
                }


                localStorage.setItem("rent",rent);
                console.log((new Date().getTime())-(localStorage.getItem("firstAccessTime")))
                if(localStorage.getItem("firstAccessTime")){
                    if((new Date().getTime())-(localStorage.getItem("firstAccessTime"))>60000){ //10分钟重置广告弹窗
                        localStorage.setItem("firstAccess",true)
                        localStorage.setItem("firstAccessTime",new Date().getTime())
                    }else{
                        localStorage.setItem("firstAccess",false)
                    }
                }else{
                    localStorage.setItem("firstAccess",true)
                    localStorage.setItem("firstAccessTime",new Date().getTime())
                }
                // Vue.prototype.$rentPath = rentJson.rentPath;
                // Vue.prototype.$rentName = rentJson.rentName;
                // Vue.prototype.$rentId = rentJson.rentId;
    
    
                if(!cacheRent||(cacheRent && rentPath !=JSON.parse(cacheRent).rentPath)){
                    debugger
                    localStorage.removeItem("firstAccessTime")
                    window.location.reload();
                }
                next()
            })
        })

    }

})


// 该段代码不需要记，理解即可
// 在vue-router在3.1.0版本之后，push和replace方法会返回一个promise对象，如果跳转到相同的路由，就报promise uncaught异常
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch((err) => err);
};


export default router